export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7039.8b3b8dfd.jpg";